import { IIAMEntity } from "./iam-entity";

export enum IAMCredentialStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export interface IIAMCredential extends Pick<IIAMEntity, "CreateDate" | "id"> {
  UserName?: string;

  AccessKeyId?: string;

  Status?: IAMCredentialStatus;

  SecretAccessKey?: string;
}

export interface IIAMCredentialMeta
  extends Omit<IIAMCredential, "SecretAccessKey"> {}

export interface IIAMCredentialUpdateRequest
  extends Required<Pick<IIAMCredential, "AccessKeyId" | "Status" | "UserName">> {}

  export enum IAMCredentialSortField {
    UserName = "UserName",
    ARN = "Arn",
    Status = "Status",
    AccessKey= "AccessKeyId",
    CreateDate = "CreateDate",
}
